import {defineStore} from 'pinia'
import {http} from '@/extensions/http'
import API_ENDPOINTS from '@/config/API_ENDPOINTS.ts'
import i18n from '@/i18n'

export const usePostStore = defineStore('post', {
    state: () => ({
        memory: {
            index: {
                en: [],
                fr: []
            } as Record<locale, Post[]>,
        }
    }),
    actions: {
        async all() {
            const locale: locale = i18n.global.locale.value

            if (this.memory.index[locale].length) return this.memory.index[locale]

            const {data} = await http.get<Post[]>(API_ENDPOINTS.POST.INDEX.replace(':chair', import.meta.env.VITE_APP_CHAIR_ID))

            this.memory.index[locale] = data

            return data
        }
    }
})